(function () {
	window.dataLayer = window.dataLayer || [];
	window.gtag =
		window.gtag ||
		function () {
			window.dataLayer.push(arguments);
		};

	function applyConsent() {
		if (typeof window.__cmp !== "function") return;

		var data;
		try {
			data = window.__cmp("getCMPData");
		} catch (e) {
			return;
		}
		if (!data || !data.purposeConsents) return;

		// Bail if consent not yet resolved (purposeConsents is an empty object).
		var hasAny = false;
		for (var k in data.purposeConsents) {
			hasAny = true;
			break;
		}
		if (!hasAny) return;

		var targeting = data.purposeConsents["c52"] === true; // Targeting
		var functional = data.purposeConsents["c53"] === true; // Functional
		var performance = data.purposeConsents["c54"] === true; // Performance

		window.gtag("consent", "update", {
			ad_storage: targeting ? "granted" : "denied",
			ad_user_data: targeting ? "granted" : "denied",
			ad_personalization: targeting ? "granted" : "denied",
			functionality_storage: functional ? "granted" : "denied",
			personalization_storage: functional ? "granted" : "denied",
			security_storage: functional ? "granted" : "denied",
			analytics_storage: performance ? "granted" : "denied"
		});
	}

	window.addEventListener("cmpEvent", applyConsent, false);
})();
